import { r as registerInstance, h, H as Host } from './index-5aea3fea.js';

const ProactiveCaseClosureModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.successMessageWasShown = false;
        this.handleClose = () => {
            this.modal.triggerClose();
        };
        this.handleModalClose = () => {
            if (this.successMessageWasShown) {
                window.location.reload();
            }
        };
        this.callId = undefined;
        this.locale = undefined;
        this.modalName = undefined;
        this.env = "prod";
        this.legacyApi = false;
        this.debug = false;
    }
    render() {
        return (h(Host, { key: 'd2d6512b55b1d4729c7a86321165665bec4d75a6' }, h("ux-modal", { key: 'b7c2fb7fda7a295dd2e9a9ab8a80260cea94a3b7', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: '94b49fb6cd870ae64cb9a8aa25975bb0e734257f' }, h("mf-proactive-case-closure", { key: '0b9c15fed661d5f3be12d9b31b4a86e16984bb61', callId: this.callId, locale: this.locale, onMfServiceCallCancel: () => this.handleClose(), onMfServiceCallSuccess: () => {
                this.handleClose();
                window.location.reload();
            }, onMfServiceCallShowSuccess: () => (this.successMessageWasShown = true), env: this.env, legacyApi: this.legacyApi, debug: this.debug })))));
    }
};

export { ProactiveCaseClosureModal as mf_proactive_case_closure_modal };

//# sourceMappingURL=mf-proactive-case-closure-modal.entry.js.map